/* Little Beat Pup: auto-apply the discount code of the day to the cart.
 * The code comes from the active announcement-bar block ([data-lbp-auto-code]).
 * - Applied right after Add to cart, on page load (cart page) and just before checkout.
 * - Never overrides a code that is already applicable (ours or typed by the customer).
 * - Clears a stale (expired) code so checkout does not complain. */
(function () {
  if (window.__lbpAutoDiscount) return;
  window.__lbpAutoDiscount = true;

  var origFetch = window.fetch.bind(window);
  var busy = false;

  function activeCode() {
    var el = document.querySelector('[data-lbp-auto-code]');
    return el ? (el.getAttribute('data-lbp-auto-code') || '').trim() : '';
  }

  function hasApplicable(cart) {
    return (cart.discount_codes || []).some(function (d) { return d.applicable; });
  }

  function hasStale(cart) {
    return (cart.discount_codes || []).some(function (d) { return !d.applicable; });
  }

  function setDiscount(code) {
    return origFetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(function (r) { return r.json(); });
  }

  // Resolves true when the cart changed (a code was applied or cleared on a cart that shows it).
  function ensure() {
    if (busy) return Promise.resolve(false);
    busy = true;
    return origFetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.item_count) return false;
        if (hasApplicable(cart)) return false;
        var code = activeCode();
        if (code) {
          return setDiscount(code).then(function (c) { return hasApplicable(c); });
        }
        if (hasStale(cart)) {
          return setDiscount('').then(function () { return false; });
        }
        return false;
      })
      .catch(function () { return false; })
      .then(function (changed) { busy = false; return changed; });
  }

  // Repaint the cart drawer (or reload the cart page) so totals show the discount.
  function refreshUI() {
    if (/^\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    origFetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) { drawer.renderContents({ id: null, sections: sections }); })
      .catch(function () {});
  }

  function run() {
    ensure().then(function (changed) { if (changed) refreshUI(); });
  }

  // After every successful Add to cart.
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(window, arguments);
    if (url.indexOf('/cart/add') > -1) {
      p.then(function (res) {
        if (res && res.ok) setTimeout(run, 150);
      }).catch(function () {});
    }
    return p;
  };

  // On page load (cart page, or a cart that already has items).
  document.addEventListener('DOMContentLoaded', run);

  // Safety net: right before checkout, make sure the code is on the cart.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[name="checkout"], a[href$="/checkout"]');
    if (!t || !activeCode()) return;
    e.preventDefault();
    e.stopPropagation();
    var go = function () { window.location.href = '/checkout'; };
    var timer = setTimeout(go, 2500);
    ensure().then(function () { clearTimeout(timer); go(); });
  }, true);
})();
